import { Card, CardContent, Skeleton } from "@tellescope/ui";

export const ContentListSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i}>
          <CardContent className="px-4">
            <div className="flex gap-3">
              <Skeleton className="w-10 h-10 rounded-lg" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
              </div>
              <Skeleton className="w-12 h-4" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
